import {
  INSURANCES_SET_LOADING,
  INSURANCES_SET_ERROR,
  INSURANCES_SET_INSURANCES,
  INSURANCES_SET_PAGINATION,
  INSURANCES_FETCH_INSURANCES,
  INSURANCES_CLEAR_ERROR,
  INSURANCES_GET_INSURANCES,
  INSURANCES_GET_PAGINATION,
  INSURANCES_GET_LOADING,
  INSURANCES_GET_ERROR
} from './types';
import { insuranceCompanyService } from '@/network';
import {
  handleAsyncAction,
  createAsyncState,
  createAsyncMutations
} from '@/utils/helpers/store';

const state = {
  insurances: [],
  pagination: {
    page: 1,
    pages: null,
    size: 10,
    count: 0
  },
  ...createAsyncState(['fetchInsurances'])
};

const mutations = {
  ...createAsyncMutations(INSURANCES_SET_LOADING, INSURANCES_SET_ERROR),
  [INSURANCES_SET_INSURANCES](state, insurances) {
    state.insurances = insurances;
  },
  [INSURANCES_SET_PAGINATION](state, pagination) {
    state.pagination = pagination;
  }
};

const actions = {
  async [INSURANCES_FETCH_INSURANCES](
    { commit },
    { companyIds, employeeId, employeeStatus, page, size }
  ) {
    return handleAsyncAction({
      commit,
      actionType: 'fetchInsurances',
      errorMessage: 'Ocurrió un error al obtener las aseguradoras',
      asyncOperation: async () => {
        const hasPagination = size > 0;

        const query = {
          companyIds,
          employeeId,
          employeeStatus
        };

        let insurances;
        if (hasPagination) {
          const { rows, ...pagination } = await insuranceCompanyService.findAll(
            {
              ...query,
              page,
              size
            }
          );
          insurances = rows;
          commit(INSURANCES_SET_PAGINATION, pagination);
        } else {
          insurances = await insuranceCompanyService.findAll({
            ...query
          });
        }
        commit(INSURANCES_SET_INSURANCES, insurances);
        return insurances;
      },
      setLoading: INSURANCES_SET_LOADING,
      setError: INSURANCES_SET_ERROR
    });
  },

  [INSURANCES_CLEAR_ERROR]({ commit }, { type }) {
    commit(INSURANCES_SET_ERROR, {
      type,
      value: null
    });
  }
};

const getters = {
  [INSURANCES_GET_INSURANCES]: (state) => state.insurances,
  [INSURANCES_GET_PAGINATION]: (state) => state.pagination,
  [INSURANCES_GET_LOADING]: (state) => state.loading,
  [INSURANCES_GET_ERROR]: (state) => state.error
};

export default {
  state,
  mutations,
  actions,
  getters
};
